import React, { useLayoutEffect } from "react";
import Tab from "./tab.js";
import "./tabManager.css";
export default function TabManager(props) {
    var _a;
    const currentTab = props.tabs.find((tab) => tab.name == props.open);
    useLayoutEffect(() => {
        if (!currentTab) {
            props.onSetOpen(props.tabs[0].name);
        }
    }, []);
    const withMaxHeight = {
        maxHeight: props.maxContainerHeight,
    };
    return (React.createElement("div", { className: "tab-manager-container" },
        React.createElement("div", { className: "tab-rail-wrapper" },
            React.createElement("div", { className: "tabs" }, props.tabs.map((tabData) => (React.createElement(Tab, { onOpen: () => {
                    props.onSetOpen(tabData.name);
                }, name: tabData.name, labelName: tabData.labelName, isOpen: props.open == tabData.name, key: tabData.name })))),
            React.createElement("div", { className: "tabs-extra-content" }, props.extraContent)),
        React.createElement("div", { style: props.containerIsFixedGrid ?
                {
                    gridTemplateRows: "minmax(0, 1fr)",
                    display: "grid",
                    ...withMaxHeight,
                }
                : { ...withMaxHeight }, className: "tab-container " +
                (props.containerIsGrid ? "tab-container-grid" : "") +
                (props.className ? ` ${props.className}` : "") }, (_a = currentTab === null || currentTab === void 0 ? void 0 : currentTab.content) !== null && _a !== void 0 ? _a : "nieznany")));
}
